import { render, staticRenderFns } from "./UserMgmt.vue?vue&type=template&id=39b0cb28"
import script from "./UserMgmt.vue?vue&type=script&lang=js"
export * from "./UserMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports